import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { Button } from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';
import Grid from '@mui/material/Grid';
import LockIcon from '@mui/icons-material/Lock';

import { shopProductsCategories } from 'modules/shop/shared/constants/shopProductsCategories';
import { ShopRelatedProductsModal } from 'modules/shop/components/ShopRelatedProductsModal';

const useStyles = makeStyles(theme => ({
  contentRow: {
    textAlign: 'center',
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(2),
  },
  lockIcon: {
    color: theme.palette.primary.main,
    fontSize: 100,
  },
  lockContainer: {
    width: 230,
  },
  unlockButton: {
    height: 50,
    padding: '5px 30px',
    fontSize: '1rem',
  },
  unlockContainer: {
    flexGrow: 1,
  },
}));

const SummaryCardLockedRating = ({ data, onUnlock }) => {
  const { t } = useTranslation();
  const classes = useStyles();

  const [isRelatedProductsModalOpen, setIsRelatedProductsModalOpen] = useState(false);

  const toggleRelatedProductsModal = () =>
    setIsRelatedProductsModalOpen(!isRelatedProductsModalOpen);

  const handleConfirm = () => {
    setIsRelatedProductsModalOpen(false);
    onUnlock();
  };

  return (
    <Grid container alignItems="center" className={classes.contentRow}>
      <Grid item className={classes.lockContainer}>
        <LockIcon className={classes.lockIcon} />
      </Grid>
      <Grid item className={classes.unlockContainer}>
        <Button
          color="primary"
          variant="contained"
          className={classes.unlockButton}
          onClick={toggleRelatedProductsModal}
        >
          {t('Unlock')}
        </Button>
        {isRelatedProductsModalOpen && data && (
          <ShopRelatedProductsModal
            data={data}
            open={isRelatedProductsModalOpen}
            onClose={toggleRelatedProductsModal}
            onConfirm={handleConfirm}
          />
        )}
      </Grid>
    </Grid>
  );
};

SummaryCardLockedRating.defaultProps = {
  onUnlock: () => {},
  data: {
    category: shopProductsCategories.creditAnalysis,
    productLine: 'Rating',
    countriesAndIndustries: [],
  },
};

SummaryCardLockedRating.propTypes = {
  onUnlock: PropTypes.func,
  data: PropTypes.shape({
    category: PropTypes.string,
    productLine: PropTypes.string,
    countriesAndIndustries: PropTypes.arrayOf(
      PropTypes.shape({
        country: PropTypes.string.isRequired,
        industries: PropTypes.arrayOf(PropTypes.string.isRequired),
      }),
    ),
  }),
};

export default SummaryCardLockedRating;
